import CampaignDetail from './CampaignDetail'
import { connect } from "react-redux";
import action from "../../../../../actions";
import * as campaignActions from './../../../../../actions/campaignAction';
import * as tagActions from './../../../../../actions/tagAction';
import * as hotelActions from './../../../../../actions/hotelAction';
import * as rateActions from './../../../../../actions/rateAction';
import * as supplierAction from './../../../../../actions/supplierAction';
import * as homestayActions from './../../../../../actions/homestayAction';
import { withRouter } from 'react-router';

const mapStateToProps = state => {
    return {
        file: state.uploadReducer,
        campaignState: state.campaignReducer,
        autoTranslateState: state.autoTranslateReducer,
        tagGroupDetailState: state.tagGroupDetailReducer,
        tagGroupState: state.tagGroupReducer,
        hotelState: state.hotelReducer,
        rateState: state.rateReducer,
        supplierState: state.supplierReducer,
        homestayState: state.homestayReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => dispatch(action.uploadAction(filters)),
        getCampaignDetail: (id) => dispatch(campaignActions.getCampaignDetail(id)),
        setCampaignDetail: (campaign) => dispatch(campaignActions.setCampaignDetail(campaign)),
        createCampaign: (campaign) => dispatch(campaignActions.createCampaignDetail(campaign)),
        updateCampaign: (campaign) => dispatch(campaignActions.updateCampaignDetail(campaign)),
        getCountries: () => dispatch(campaignActions.getCountries()),
        getChannels: () => dispatch(campaignActions.getChannels()),
        getAllSku: (typeKey) => dispatch(tagActions.getAllSku(typeKey)),
        getAllHotel: () => dispatch(hotelActions.getAllHotels()),
        getListRates: (filters) => dispatch(rateActions.getListRates(filters)),
        getMarkupPromotionConfig: (filters) => dispatch(campaignActions.getMarkupPromotionConfig(filters)),
        getMarkupPromotionFly: () => dispatch(campaignActions.getMarkupPromotionFly()),
        getMarkupBundleMinValue: (data) => dispatch(campaignActions.getMarkupBundleMinValue(data)),
        getPromotionBanks: () => dispatch(campaignActions.getPromotionBanks()),
        createCampaignTranslate: (campaign, promotionExtended, languageCode, languageName) => dispatch(campaignActions.createCampaignTranslate(campaign, promotionExtended, languageCode, languageName)),
        updateCampaignTranslate: (campaign, promotionExtended, languageCode, languageName) => dispatch(campaignActions.updateCampaignTranslate(campaign, promotionExtended, languageCode, languageName)),
        getTagsByGroup: (params) => dispatch(tagActions.getTagsByGroup(params)),
        getSupplierAll: (params) => dispatch(supplierAction.getSupplierListAll(params)),
        getAllHomestay: () => dispatch(homestayActions.getAllHomestays()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CampaignDetail))
